import { Record, Map, List } from 'immutable'
import { USA_ISO, USA_CODE } from 'app/constants/phoneCountryCodes'
import { ILocalSettings } from './interface'

const LocalSettingsRecord = Record<ILocalSettings>(
  {
    isOneSignalInitialized: false,
    isTopNotificationBlockShown: null,
    isPushEnabled: false,
    isOptedOut: false,
    isNotificationsBlocked: false, // not available by browser, or user block it manually
    isPending: false,
    isShowConfirmationModalForSwitchProTrack: false,
    isShowConfirmationModalForStopProTrack: false,
    isShowConfirmationModalForDifferentProTrack: false,
    isShowLoginInformationModal: false,
    isShowConfirmationModalForCommitPreviousActivity: false,
    isShouldAutoPlayVideo: false,
    loadedLanguages: Map(),
    queries: Map(),
    countriesCodes: List([Map({ country: USA_ISO, code: USA_CODE })]),
    breadcrumbs: List([]),
  },
  'LocalSettings'
)

export default class LocalSettings extends LocalSettingsRecord {}
